// extracted by mini-css-extract-plugin
module.exports = {"wfp--theme-dark":"styles_wfp--theme-dark__-GxvL","wfp--theme-dark--auto":"styles_wfp--theme-dark--auto__32pxL","adhoc-tag":"styles_adhoc-tag__1OoX0","error":"styles_error__1vTTX"};